import { Globals } from "./../global";
import { GameService } from "./game.service";
import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { tap } from "rxjs/operators";
import { Observable } from "rxjs";
import { BehSubjectService } from "./beh-subject.service";

@Injectable({
  providedIn: "root"
})
export class LoginService {
  private httpOptions;
  private deviceId;
  protected subProducts = [];

  constructor(
    private http: HttpClient,
    private gameservice: GameService,
    public global: Globals,
    private beh: BehSubjectService
  ) { }

  createOrder() {
    return this.http.get("http://oman-giga-he/hemsisdn/");
  }

  getProduct() {
    let requestHeader = this.global.getHeaders(true);
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));
    return this.http.get(this.global.baseUrl + "product", {
      headers: requestHeader
    });
  }

  askPin(msisdn) {
    let requestHeader = this.global.getHeaders(true);
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));
    const body = {
      msisdn: msisdn,
      operatorId: this.global.operatorId
    };
    return this.http.post(this.global.baseUrl + "player/sendOTP", body, {
      headers: requestHeader
    });
  }

  registerHe(msisdn) {
    let requestHeader = this.global.getHeaders(true);
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));

    localStorage.setItem("heSession", this.global.generateTXID())
    return this.http.get(this.global.baseUrl + "player/he/?op=" + this.global.operatorId + "&msisdn=" + msisdn + "&session=" + localStorage.getItem("heSession"))
  }

  validatePin(msisdn, pin, isHE: boolean = false) {
    msisdn.replace(' ', '');
    let callheader = isHE ? this.global.getHeaders().set('he-session', `${this.global.operatorId}#${msisdn}`).set('twt-he-msisdn', `${msisdn}`) : this.global.getHeaders();
    this.beh.apiRequest$.next(JSON.stringify({ header: callheader, body: null }));

    let body: any = {
      msisdn: msisdn,
      pin: pin,
      operatorId: this.global.operatorId,
    };

    return this.http.post(this.global.baseUrl + "player/login", body, {
      headers: callheader
    });
  }

  productBuy(searchKey) {
    let requestHeader = this.global.getHeaders(true);
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));
    const body = {};
    return this.http.post(this.global.baseUrl + "product/" + searchKey, body, {
      headers: requestHeader
    });
  }
  unsub() {
    let requestHeader = this.global.getHeaders(true);
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));
    return this.http.delete(this.global.baseUrl + "product/SUBSCRIPTION", {
      headers: this.global.getHeaders(true)
    });
  }
  connectSocialNetwork(socialNetwork, socialId, socialName, picUrl = "null") {
    let requestHeader = this.global.getHeaders(true);
    this.beh.apiRequest$.next(JSON.stringify({ header: requestHeader, body: null }));
    if (picUrl == "null") {
      var pic = "http://graph.facebook.com/" + socialId + "/picture";
    } else {
      var pic = picUrl;
    }
    const body = {
      socialNetwork: socialNetwork,
      socialId: socialId,
      profilePicture: pic,
      name: socialName
    };
    return this.http.post(this.global.baseUrl + "player/socialnetwork", body, {
      headers: requestHeader
    });
  }

  getHe() {
    return this.http.get(this.global.baseUrlSimple + "he-check")
  }
}
